import { createApi } from '@reduxjs/toolkit/query/react';
import { createTimelyBaseQuery } from 'api/core/base';
import type { RecurrenceBudgetList } from 'types/recurrenceBudget';

/**
 * RTK Query API slice for per-period recurring budgets (TT-5786).
 * Scoped to the current account via createTimelyBaseQuery's account prefix.
 *
 * Read-only: the schedule is written through the project save
 * (`upcoming_budget`), which invalidates the RecurrenceBudget tag.
 */
export const recurrenceBudgetApi = createApi({
  reducerPath: 'recurrenceBudgetApi',
  baseQuery: createTimelyBaseQuery(),
  tagTypes: ['RecurrenceBudget'],
  endpoints: build => ({
    getRecurrenceBudgets: build.query<RecurrenceBudgetList, { projectId: number }>({
      query: ({ projectId }) => ({ url: `projects/${projectId}/recurrence_budgets` }),
      providesTags: (result, error, { projectId }) => [{ type: 'RecurrenceBudget', id: projectId }],
    }),
  }),
});

export const { useGetRecurrenceBudgetsQuery } = recurrenceBudgetApi;
